import { Component } from '@angular/core';

@Component({
  selector: 'atlas-panel-description',
  templateUrl: './panel-description.component.html',
  styleUrls: ['./panel-description.component.scss'],
  standalone: false,
})
export class PanelDescriptionComponent {}
